// eslint-disable-next-line import/prefer-default-export
export const projectLogColorMapping = {
  new: 'var(--blue-500)',
  update: 'var(--orange-500)',
  submit: 'var(--green-500)',

  // Project status
  liquidation: 'var(--orange-500)',
};

export const registerResultReviewStatusColorMapping = {
  draft: 'var(--gray-500)',
  submitted: 'var(--blue-500)',
  underReview: 'var(--orange-500)',
  approved: 'var(--green-500)',
  rejected: 'var(--red-500)',
};
